<template>
  <!--
      NOTE §3.4 — HexagonImage uses an SVG <mask> with a hexagon.png raster image.
      This is NOT a CSS clip-path: polygon() and does not violate the hard rule.
      If the brand direction changes further away from hexagonal shapes,
      replace the mask with the BrandWave or a rounded-corner container.
  -->
  <component
      :is="to ? NuxtLink : href ? 'a' : 'div'"
      :class="[additionalClass, (to || href) ? 'cursor-pointer transition duration-200 hover:scale-105' : '', title ? 'flex flex-col items-center gap-2' : '']"
      :href="href ?? undefined"
      :rel="href ? 'noopener noreferrer' : undefined"
      :to="to ?? undefined"
  >
    <div
        class="svgMask noprint drop-shadow-md"
        style="position: relative; width: 100%; height: 0; padding-bottom: 115.42%;"
    >
      <svg
          baseProfile="full"
          preserveAspectRatio="xMidYMid slice"
          style="width:100%; height:100%; position:absolute;"
          version="1.2"
          viewBox="0 0 1000 100"
      >
        <defs>
          <mask
              :id="maskId"
              maskContentUnits="userSpaceOnUse"
              maskUnits="userSpaceOnUse"
              transform="scale(1)"
          >
            <image
                height="100%"
                width="100%"
                xlink:href="/images/hexagon/hexagon-rounded.png"
            />
          </mask>
        </defs>
        <image
            :href="(imgSrc.indexOf('http') === 0) ? imgSrc : '/images/hexagon/' + imgSrc"
            :mask="`url(#${maskId})`"
            height="100%"
            width="100%"
            x="0"
            y="0"
        />
      </svg>
    </div>
    <span
v-if="title"
class="font-semibold text-center h3 !text-white "
>{{ title }}</span>
  </component>
</template>
<script setup lang="ts">
import {NuxtLink} from '#components';

interface Props {
  imgSrc?: string
  additionalClass?: string
  href?: string
  to?: string | object
  title?: string
}
withDefaults(defineProps<Props>(), {
    imgSrc: 'BQ4C3479.jpg',
    additionalClass: '',
    href: undefined,
    to: undefined,
    title: undefined,
});
const maskId = useId();
</script>
<style scoped>
</style>
